export default __webpack_public_path__ + "static/media/preview_image_yt.f0b9650b.png";